import { useEffect } from 'react';
import { PAGES, SECTIONS } from '../Admin/components/charitySetup/onboarding/onboardingCustomation/constants';

interface UseAutoSelectSectionProps {
  iframeLoaded: boolean;
  dataInitialized: boolean;
  selectedSection: any;
  selectedPage: string;
  onSectionSelect: (section: any) => void;
}

export function useAutoSelectSection({
  iframeLoaded,
  dataInitialized,
  selectedSection,
  selectedPage,
  onSectionSelect
}: UseAutoSelectSectionProps) {
  useEffect(() => {
    if (iframeLoaded && dataInitialized && selectedSection?.id === SECTIONS.NONE.id) {
      let sectionToSelect;
      if (selectedPage === PAGES.GIVING_PAGE) {
        sectionToSelect = SECTIONS.GIVING_BANNER;
      } else if (selectedPage === PAGES.POST_DETAILS_PAGE) {
        sectionToSelect = SECTIONS.POST_DETAIL_MAIN;
      } else {
        sectionToSelect = SECTIONS.NEWSFEED_NAVBAR;
      }
      
      onSectionSelect(sectionToSelect);
    }
  }, [iframeLoaded, dataInitialized, selectedSection, selectedPage, onSectionSelect]);
}